<template>
    <div>
        <el-form :inline="true" :model="queryParams"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="分类名称">
                <el-input v-model="queryParams.productCategoryName" placeholder="请输入分类名称" clearable></el-input>
            </el-form-item>
<!--            <el-form-item label="分类类型">-->
<!--                <el-select v-model="queryParams.categoryKey" placeholder="请选择分类类型" clearable>-->
<!--                    <el-option-->
<!--                            v-for="item in type"-->
<!--                            :key="item.id"-->
<!--                            :label="item.value"-->
<!--                            :value="item.value">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item>
                <el-button type="primary" size="mini" @click="getCategoryList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
            </el-form-item>
        </el-form>


        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="addButton()"
                >新增菜品分类</el-button>
            </el-col>
<!--            <el-col :span="1.5">-->
<!--                <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        icon="el-icon-plus"-->
<!--                        size="mini"-->
<!--                        @click="addTypeButton()"-->
<!--                >新增套餐分类</el-button>-->
<!--            </el-col>-->
            <el-col :span="1.5">
                <el-button
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        size="mini"
                        :disabled="isDelete"
                        @click="delList"
                >删除</el-button>
            </el-col>

        </el-row>
        <el-table
                :data="list"
                style="width: 100%;margin-bottom: 20px;line-height: 0"
                @selection-change="handleSelectionChange"
                row-key="id"
                show-header
                border>
            <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column label="商品分类名称" align="center" prop="productCategoryName" :show-overflow-tooltip="true" />
<!--            <el-table-column label="分类类型" align="center" prop="productCategoryType"/>-->
            <el-table-column label="显示顺序" align="center" prop="sortNum" sortable width="120"/>
            <el-table-column label="状态"  align="center" width="150">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status=='0'">正常</el-tag>
                    <el-tag type="danger" v-if="scope.row.status=='1'">停用</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" align="center" prop="createTime">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="modifyButton(scope.row)"
                    >修改</el-button>
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            @click="delList(scope.row)"
                    >删除</el-button>
                </template>

            </el-table-column>
        </el-table>
        <template v-if="list.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body destroy-on-close>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="分类名称" prop="productCategoryName">
                            <el-input v-model="form.productCategoryName" placeholder="请输入分类名称" maxlength="30" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="分类类型" v-if="form.id!=0">
                            <el-select v-model="form.productCategoryType" placeholder="请选择分类类型" clearable>
                                <el-option
                                        v-for="item in type"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="显示顺序" prop="sortNum">
                            <el-input-number v-model="form.sortNum" controls-position="right" :min="0"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <row>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-radio-group v-model="form.status">
                                <el-radio label="0">启用</el-radio>
                                <el-radio label="1">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                //店铺id
                shopId:0,
                isDelete:true,
                form: {},
                open:false,
                title: "",
                list: [],//菜单
                //加载状态
                loading: false,
                total: 0,
                //查询数据
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    productCategoryName:"",
                    categoryKey:"",
                    shopId:0
                },
                rules: {
                    productCategoryName: [
                        {required: true, message: '请输入分类名称', trigger: 'blur'},
                        {min:2,max: 8, message: '分类名称需在2~8个字符', trigger: 'blur'},
                    ],
                    sortNum: [
                        {required: true, message: '请输入角色显示顺序', trigger: 'blur'},
                    ],
                },
                selectedRows: [],
                //分类类型列表
                type:[
                    {
                        id:1,
                        value:"菜品分类",
                    },
                    {
                        id:2,
                        value:"套餐分类",
                    }
                ],
            }
        },
        mounted() {
            this.getCategoryList();
        },
        created(){
            //获取缓存中的shopId
            this.shopId=window.sessionStorage.getItem("shopId");
        },
        methods: {
            addTypeButton(){
                this.reset();
                this.title="新增套餐分类";
                this.form.productCategoryType="套餐分类";
                this.open=true;
            },
            async delList(row) {
                if (row.id){
                    this.selectedRows=[];
                    this.selectedRows.push(row.id);
                }
                this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async ()=>{
                    const {data: res} = await this.$http.post("productCategory/delProductCategory", this.selectedRows)
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                        this.getCategoryList();
                    }else if (res.code==50008){
                        this.$message.error('请确保所删除的店铺分类中没有可使用的店铺！')
                    }else {
                        this.$message.error('删除失败')
                    }
                }).catch((e) => {
                    this.$message.info('已取消删除！')
                })

            },
            /**
             * 修改按钮操作
             * */
            modifyButton(rowData){
                this.form=rowData;
                this.open=true;
            },
            cancel(){
                this.reset();
                this.open=false;
            },
            reset(){
                this.form={
                    id:0,
                    productCategoryName:'',
                    productCategoryType:'',
                    sortNum:0,
                    status:"0",
                }
            },
            /**修改用户*/
            async modifyFrom() {
                const {data: res} = await this.$http.post('productCategory/updateProductType',JSON.parse(JSON.stringify(this.form)));
                if (res.code==200){
                    this.$message.success('修改成功')
                    this.getCategoryList();
                }else if(res.code==50013){
                    this.$message.error('店铺分类已存在！')
                }else {
                    this.$message.error('服务器异常')
                }
            },
            /**
             * 添加用户
             * */
            async addFromFun() {
                const {data: res} = await this.$http.post('productCategory/insertProductType', this.form);
                console.log(res)
                if(res.code==200){
                    this.$message.success('添加成功')
                    this.getCategoryList();
                }else if(res.code==50013){
                    this.$message.error('店铺分类已存在!')
                }else{
                    this.$message.error('服务器异常')
                }
            },
            /** 提交按钮 */
            async submitForm() {
                console.log(this.form)
                await this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.id != 0) {
                            this.modifyFrom();
                        } else {
                            this.addFromFun();
                        }
                    }
                });
                this.open = false
            },
            //添加按钮操作
            addButton(){
                this.reset();
                this.title="新增菜品分类";
                this.form.productCategoryType="菜品分类";
                this.open=true;
            },
            //重置
            resetQuery(){
                this.queryParams= {
                    pageNum: 1,
                    pageSize: 10,
                    productCategoryName:"",
                    categoryKey:"",
                    shopId: 0
                }
                this.getCategoryList();
            },
            /**
             * 获取多选ids
             * **/
            handleSelectionChange(rows) {
                const newArr = []
                rows.forEach((item) => {
                    newArr.push(item.id)
                });
                this.selectedRows = newArr;
                console.log(this.selectedRows)
                if (this.selectedRows.length!=0){
                    this.isDelete=false;
                }else {
                    this.isDelete=true;
                }
            },
            /**
             * 获取分类列表
             * @returns {Promise<void>}
             */
            async getCategoryList() {
                this.queryParams.shopId=this.shopId;
                console.log(this.queryParams)
                const {data: res} = await this.$http.get("productCategory/getProductCategoryList", {params:this.queryParams});
                console.log(res)
                this.list=res.data.children;
                this.total=res.data.total;
            },
            handleSizeChange(val) {
                this.queryParams.pageSize=val;
                this.getCategoryList();
            },
            handleCurrentChange(val) {
                this.queryParams.pageNum=val;
                this.getCategoryList();
            }
        },
    }

</script>

<style scoped>

</style>
